
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '@/store/consultorioStore';
import { globalStore } from '@/store/globalStore';
import { consultorioService } from '@/services/ConsultorioService';
import { AxiosResponse } from "axios";
  
@Component({
	name: "FichaEndodoncia",
})
  
export default class FichaEndodoncia extends Vue {
	@Prop() paciente_id!: any
	@Prop() cita!: any
	@Prop() swEditar!: any
	@Prop() ficha_selected!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	private tab:any = null;
	piezas = [];
	pieza_dental = null;
	antecedentes = '';
	estado_actual = '';
	valid = true;
	preguntas = [];
	cerrada = ['SI','NO'];
	esqueleticos = ['Nota1','Nota2','Nota3','Nota4'];
	deseo_tratamiento = ['Voluntad propia','Voluntad de los padres','Profesional'];
	comportamiento = ['Responsable','Irresponsable']
	respuestas = []
	private fecha = DateTime.now().toFormat("yyyy-MM-dd");
	get tratamientos(): any {
		return this.consultorioStore.tratamientos;
	}
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get tipo_ficha(): any {
		let tipo = '';
		if(this.cita && this.cita.tratamiento_id == 17){
			tipo = 'ORTODONCIA'
		}
		return tipo;
	}
	mounted(){
		this.getPiezas();
		this.getPreguntasEndodoncia()
		this.getRespuestas();
	}
	
	
	async getPiezas() {
		await http.get('get-piezas').subscribe({
			next: (response:AxiosResponse) => {
				this.piezas = response.data;
			},
		})
	}
	async getPreguntasEndodoncia() {
		this.consultorioStore.loading = true;
		let data= {
			ficha: 'ORTODONCIA'
		}
		await http.get('get-preguntas-endodoncia',{params: data}).subscribe({
			next: (response:AxiosResponse) => {
				this.preguntas = response.data;
				this.consultorioStore.loading = false;
			},
		})
	}

	select_opciones(tipo:string,pregunta:string) {
	let opciones:any[] = []
	let respiracion = ['Nasal','Bucal'], inperposicion_lingual = ['Normal','Interposicion Alta','Media','Baja'], volumen_labios = ['Normales','Finos','Voluminosos'];
	const mobilidad_lingual = ['Normal','Limitada','Ausente'], test_avance_mandibular = ['Mejora con el avance','Peora con el avance'];
	const desvio_mandibular = ['Desvio funcional lado derecho','Izquierdo','Desvio para frente'], degrade_distal = ['Sin degrade','Degrade Mesial','Degrade Distal'];
	const clasificacion_angle = ['Clase 1','Clase 2','Clase 3'], analisis_moyers = ['Inferior Derecho','Izquierdo','Superior Derecho','Izquierdo'];
	const anatomia_dentaria = ['Dientes conoides','Anomalos'], curva_spee = ['Leve','Moderada','Profunda'], maxila_craneo = ['Bien posicionada','Retruida','Protruida'];
	const tamanho_mandibula = ['Grande','pequena'], afai = ['Normal','Aumentda','Disminuida'], fma = ['Crecimiento normal','Vertical','Horizontal'];
	const posicion_incisivo_sup = ['Bien posicionada','Retruido','Protruido'], faringe_superior = ['Normal','Disminuida'], faringe_inferior = ['Normal','Aumentada'];
	const angulo_facial = ['Crecimiento Normal','Vertical','Horizontal'], inclinacion = ['Normal','Linguoversionado','Labioversionado'];
	const posicion_molar = ['Normal','Mesializado','Distalizado'], altura_facial = ['Crecimiento Normal','Vertical','Horizontal'];
	const padron_crecimiento = ['Normocefalo','Dolicocefalo','Branquicefalo']
	switch (tipo) {
		case 'CERRADA':
			opciones = this.cerrada
			break;
		case 'SELECCION':
			if(pregunta == 'Deseo del Tratamiento') {
				opciones = this.deseo_tratamiento;
			}
			if(pregunta == 'Comportamiento') {
				opciones = this.comportamiento;
			}
			if(pregunta == 'Equilibrio Facial' || pregunta == 'Tercio Inferior' || pregunta == 'Maxila Cráneo' ||
				pregunta == 'Mandíbula Cráneo' || pregunta == 'Espacio Interlabial' || pregunta == 'Exposicion Incisal' ||
				pregunta == 'Sonriso Gingival' || pregunta == 'Surco Labiomental' || pregunta == 'Linea cuellomental' ||
				pregunta == 'Angulo Nasolabial' || pregunta == 'Surco Nasolabial' || pregunta == 'Simetria Facial' ||
				pregunta == 'Linea Mediana Superior' || pregunta == 'Linea Mediana Inferior'
			) {
				opciones = this.esqueleticos;
			}
			if(pregunta == 'Respiracion') {
				opciones = respiracion
			}
			if(pregunta == 'Interposición Lingual') {
				opciones = inperposicion_lingual
			}
			if(pregunta == 'Volumen de los labios') {
				opciones = volumen_labios
			}
			if(pregunta == 'Movilidad Lingual') {
				opciones = mobilidad_lingual
			}
			if(pregunta == 'Test de Avance Mandibular') {
				opciones = test_avance_mandibular
			}
			if(pregunta == 'Desvío de la mandibula') {
				opciones = desvio_mandibular
			}
			if(pregunta == 'Degrade distal de los molares Deciduos') {
				opciones = degrade_distal
			}
			if(pregunta == 'Clasificación de Angle' || pregunta == 'Clas. de Angle' || pregunta == 'Llave de Caninos') {
				opciones = clasificacion_angle
			}
			if(pregunta == 'Análisis de Moyers') {
				opciones = analisis_moyers
			}
			if(pregunta == 'Anatomia dentaria') {
				opciones = anatomia_dentaria
			}
			if(pregunta == 'Curva de Spee') {
				opciones = curva_spee
			}
			if(pregunta == 'Maxila-Craneo (A N Perpendicular)' || pregunta == 'Mandibula-Cráneo (Pog-N Pep)') {
				opciones = maxila_craneo
			}
			if(pregunta == 'Tamaño de la Mandibula (Co-Gn)') {
				opciones = tamanho_mandibula
			}
			if(pregunta == 'AFAI (ENA-Me)') {
				opciones = afai
			}
			if(pregunta == 'FMA (Po-Or)(Go-Me)') {
				opciones = fma
			}
			if(pregunta == 'Posicion incisivo Sup, (Sf1-a Perp)') {
				opciones = posicion_incisivo_sup
			}
			if(pregunta == 'Faringe Superior (Nfa-Nfp)') {
				opciones = faringe_superior
			}
			if(pregunta == 'Faringe Inferior (Bfa-Bfp)') {
				opciones = faringe_inferior
			}
			if(pregunta == 'Angulo del eje facial Ba-N-Ptm-Gn') {
				opciones = angulo_facial
			}
			if(pregunta == 'Inclinación del incisivo superior' || pregunta == 'Inclinación del incisivo inferior') {
				opciones = inclinacion
			}
			if(pregunta == 'Posición Molar Superior') {
				opciones = posicion_molar
			}
			if(pregunta == 'Altura Facial Inferior Xi Ena-xi-pme') {
				opciones = altura_facial
			}
			if(pregunta == 'Padrón de Crecimiento') {
				opciones = padron_crecimiento
			}
			
			break;
		default:
			break;
	}
	return opciones;
}
	guardar(){
		if (!this.$refs.form.validate()) {
			Alert.warning( `Lene todos los campos obligatorios (*)`)
			return;
		}
		let data = {
			paciente_id: this.paciente_id,
			cita_id: this.cita.id,
			preguntas_x_clasificacion: this.preguntas,
			tipo_ficha: this.tipo_ficha,
			ficha_id: this.ficha_selected?this.ficha_selected.id:null
		}
		if(!this.swEditar){
			Alert.confirm(`Se realizará el registro de la ficha`, 'Registrar nueva Ficha?').then(async result => {
				if(result.isConfirmed){
					await this.consultorioService.registrarFicha(data)
					
				}
			})
		}else {
			
			Alert.confirm(`Se realizará la modificacion de la ficha`, 'Modificar ficha?').then(async result => {
				if(result.isConfirmed){
					await this.consultorioService.updateFicha(data)
				}
			})
		}
		
	}

	async cargarDatos(){
		if(this.swEditar){
			this.pieza_dental = this.ficha_selected.pieza_dental_id;
			this.antecedentes = this.ficha_selected.antecedentes;
			this.estado_actual = this.ficha_selected.estado_actual;
			this.fecha = this.ficha_selected.fecha
			this.preguntas.forEach(element => {
					element.preguntas.forEach(el => {
					let respuesta = this.respuestas.find(val => val.pregunta_id == el.id)
					if(respuesta){
						//console.log(respuesta)
						el.respuesta = respuesta.respuesta;
						el.observacion = respuesta.observacion
						console.log(el)
					}
				});
			});

		}
	}

	async getRespuestas() {
	await http.get(`get-respuestas-paciente/${this.paciente_id}`).subscribe({
		next: (response:AxiosResponse) => {
			this.respuestas = response.data;
			this.cargarDatos();
		},
	})
}

	
	
}
  
